<template>
    <nav>
        <router-link :class="{selected: item.id === current}"
                     :key="index"
                     :to="item.to"
                     v-for="(item, index) in routes">

            <Icon :name="item.icon" class="icon"/>
            <span class="text">{{item.title}}</span>

        </router-link>
    </nav>
</template>

<script>
    import Icon from './Icon';

    export default {
        name: 'PageNavigation',
        components: {Icon},
        data() {
            return {
                current: null,
                routes: [
                    {title: 'Home', icon: 'home', to: '/', id: 'home'},
                    {title: 'Upload', icon: 'publish', to: '/upload', id: 'upload'},
                    {title: 'Files', icon: 'dns', to: '/files', id: 'files'},
                    {title: 'Token', icon: 'admin_panel_settings', to: '/token', id: 'token'},
                    {title: 'Shorts', icon: 'link', to: '/links', id: 'links'},
                ]
            };
        },
        methods: {
            routeChanged(to) {
                this.current = to?.meta?.nav;
            },
        },
        created() {
            this.$router.afterEach(this.routeChanged);
            this.routeChanged(this.$route);
        }
    };
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
    nav {
        background: #051e34;
        z-index: 10;
        box-shadow: 0 -1px 4px #00000066;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        place-content: space-evenly;
        overflow: hidden;
    }

    a {
        justify-content: center;
        display: flex;
        flex-direction: column;
        flex: 1;
        border-radius: 4px 8px 8px 4px;
        text-decoration: none;
        color: #ffffffaa;
        padding: 4px 8px;
        transition: color .3s, background-color .3s, border-left-color .3s;
    }


    .icon {
        font-size: 1.7em;
        display: block;
        transform: translateY(30%);
        transition: transform .2s;
    }

    .text {
        display: block;
        opacity: 0;
        font-size: .9em;
        transition: opacity .2s;
    }

    .selected {
        color: #41b181;
    }

    .selected .text {
        opacity: 1;
    }

    .selected .icon {
        transform: translateY(0);
    }


    @media screen and (min-width: 500px) {
        nav {
            background: #062540;
            flex-direction: column;
            flex-wrap: nowrap;
            overflow-y: auto;
            justify-content: start;
            padding-top: 12px;
        }

        a {
            border-left: 4px solid transparent;
            flex: 1;
        }
    }

    @media screen and (min-height: 400px) {
        a {
            padding-top: 16px;
            padding-bottom: 16px;
            flex: unset;
        }
    }

    @media screen and (min-width: 1200px) {
        a {
            flex-direction: row;
            align-items: center;
            justify-content: left;
            font-size: 1.2em;
            margin: 4px 12px 4px 0;
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
        }

        a.selected {
            border-left-color: #37378d;
            /*background-color: #24245e;*/
        }

        a:hover {
            background-color: #242471;
        }

        .icon {
            padding: 4px;
            transform: translateY(0);
        }

        .text {
            opacity: 1;
            font-weight: bold;
        }
    }

</style>
